import { Category } from '@/core/entity';
import { ICategoryGateway, CategoryInput, UpdaterFunc, PresenterFunc } from '@/core/interface';
import { CreateCategory, UpdateCategory, RemoveCategory } from '@/core/usecase';

export class CategoryController {
  constructor(
    private readonly categoryGw: ICategoryGateway,
  ) { }

  public create(
    input: CategoryInput,
    presenter: PresenterFunc<Category | null>,
    updater?: UpdaterFunc,
  ) {
    const useCase = new CreateCategory(this.categoryGw);

    useCase.execute(input, presenter, updater);
  }

  public remove(
    id: string,
    presenter: PresenterFunc<Category | null>,
    updater?: UpdaterFunc,
  ) {
    const useCase = new RemoveCategory(this.categoryGw);

    useCase.execute(id, presenter, updater);
  }

  public update(
    id: string,
    input: CategoryInput,
    presenter: PresenterFunc<Category | null>,
    updater?: UpdaterFunc,
  ) {
    const useCase = new UpdateCategory(this.categoryGw);

    useCase.execute(id, input, presenter, updater);
  }
}
